import {Component, OnInit} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormArray,
  Validators,
  ValidationErrors,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';
import {
  FormBuilderService,
  ApplicationService,
  NotificationService,
  TypesService,
  CommunicationService, SalesService
} from '../../services';
import {
  OriginatorBrokerModel,
  CustomerDetailsModel,
  AbnAcnModel,
  BorrowerTypeModel,
  CompanyDetailsModel,
  CarLoanDetailsModel,
  IndividualCompanyModel,
  LoanDetailsModel,
  LoanDetailsTermsModel,
  ApplicationTypeModel,
  HomeLoanDetailsModel,
  SecurityDetailsModel,
  SolicitorPanelDetailsModel,
  SolicitorBorrowerDetailsModel,
  RateModel,
  IncomeDetailsModel,
} from '../../models/widgets';
import {
  PersonalDetailsModel,
  IndividualPersonModel,
  IndividualPhoneModel, IndividualNonApplicantModel
} from '../../models/widgets/personal-details-model';
import {TrustDetailsModel, IndividualTrustModel} from '../../models/widgets/trust-details-model';
import {BorrowerTypeInfo} from '../widgets';
import {AutoCollateralModel} from '../../models/widgets/auto-collateral-model';
import {BalloonAmountModel} from '../../models/widgets/balloon-amount-model';
import {LoanTermsModel} from '../../models/widgets/loan-terms-model';
import {SingleSplitLoanAmountModel} from '../../models/widgets/single-split-loan-amount-model';
import {SubmitModel} from '../../models/widgets/submit-model';
import {DocumentDetailsModel} from '../../models/widgets/documents-upload-model';
import {SubmissionService, SubmissionDefaults} from '../../services';
import {AssetsDetailsModel} from '../../models/widgets/assets-details-model';
import {LiabilitiesDetailsModel} from '../../models/widgets/liabilities-details-model';
import {ExpensesDetailsModel} from '../../models/widgets/expenses-details-model';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router, ActivatedRoute} from '@angular/router';
import {QuoteDetailsModel} from '../../models/widgets/quote-details-model';
import {QuoteResultsModel} from '../../models/widgets/quote-results-model';
import {WorkbookService} from '../../services';
import {QuotesListModel} from '../../models/widgets/quotes-list-model';
import {BrokerNotesModel} from '../../models/widgets/broker-notes-model';
import {ProductModel} from '../../models/widgets';
import {InvestmentIncomeDetailsModel} from '../../models/widgets/investment-income-model';
import {EmploymentDetailsModel} from '../../models/widgets/employment-details-model';
import * as _ from 'lodash';
import {BehaviorSubject, Observable} from 'rxjs';
import { BorrowerTypeEnhancedModel } from '../../models/widgets/borrower-type-enhanced-model';
import {debounceTime, pairwise, startWith, take} from 'rxjs/operators';
import {CanDeactivateComponent} from '../../_global/guards/can-deactivate.guard';
import {JwtHelperService} from '@auth0/angular-jwt';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {BrokerNotesComponent} from '../widgets/broker-notes/broker-notes.component';
import {ProductComponent} from '../widgets/product/product.component';
import {RateComponent} from '../widgets/rate/rate.component';
import {
  SolicitorBorrowerDetailsComponent,
  SolicitorPanelDetailsComponent,
  SecurityDetailsComponent,
  HomeLoanDetailsComponent,
  ApplicationTypeComponent,
  LoanDetailsTermsComponent,
  QuotesListComponent,
  QuoteDetailsComponent,
} from '../widgets';
import {ConfirmationComponent} from '../widgets/confirmation/confirmation.component';
import {SubmitComponent} from '../widgets/submit/submit.component';
import {DocumentUploadComponent} from '../widgets/documents-upload/documents-upload.component';
import {AutoCollateralComponent} from '../widgets/auto-collateral/auto-collateral.component';
import {ExpensesDetailsComponent} from '../widgets/expense-details/expenses-details.component';
import {LiabilitiesDetailsComponent} from '../widgets/liabilities-details/liabilities-details.component';
import {AssetsDetailsComponent} from '../widgets/assets-details/assets-details.component';
import {IncomeDetailsComponent} from '../widgets/income-details/income-details.component';
import {InvestmentIncomeComponent} from '../widgets/investment-income/investment-income.component';
import {EmploymentDetailsComponent} from '../widgets/employment-details/employment-details.component';
import {BalloonAmountComponent} from '../widgets';
import {LoanTermsComponent} from '../widgets';
import {SingleSplitLoanAmountComponent} from '../widgets';
import {LoanDetailsComponent} from '../widgets';
import {BusinessCarLoanDetailsComponent} from '../widgets';
import {PersonalDetailsComponent} from '../widgets';
import {CompanyDetailsComponent} from '../widgets';
import {TrustDetailsComponent} from '../widgets/trust-details/trust-details.component';
import {BorrowerTypeEnhancedComponent} from '../widgets/borrower-type-enhanced/borrower-type-enhanced.component';
import {BorrowerTypeComponent} from '../widgets';
import {AbnAcnComponent} from '../widgets';
import {CustomerDetailsComponent} from '../widgets';
import {OriginatorBrokerComponent} from '../widgets';
import {MatButtonModule} from '@angular/material/button';
import {MatListModule} from '@angular/material/list';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {NgClass, NgIf, NgFor} from '@angular/common';
import {MatSidenavModule} from '@angular/material/sidenav';
import {DataHandlerService} from '../../services/data-handler.service';
import {LCA_ORIGINATOR_PARTY_ROLE_ID, RETAIL} from '../../_global/wiz.constants';

/**
 * The base form for all wizards. Put reusable logic here
 */

export interface WizardSteps {
  name: string;
  widgets: WidgetConfig[]; // widget names that should appear for that step
  icon: string;
  condition?: any;
  classNameStatus: string;
}

export interface WidgetConfig {
  name: string;
  class: string;
  opts?: any; // maybe pass any other opts specific to that wizard
}

interface CompanyDefaults {
  name: string;
  abn: string;
  acn: string;
  entity: {
    ind: string,
    text: string
  };
  asic: {
    asicorganisationnumberheadingField: string,
    asicorganisationnumberField: string,
    asicbusinessregistrationnumberField: string,
    aSICNumberField: string,
    aBNStatusFromDateField: string
  };
}

@Component({
  selector: 'app-wizard-form',
  templateUrl: './wizard-form.component.html',
  styles: [],
  standalone: true,
  imports: [MatSidenavModule, NgClass, MatProgressBarModule, NgIf, MatListModule, NgFor, MatButtonModule, MatButtonModule,
    FormsModule, OriginatorBrokerComponent, ReactiveFormsModule, CustomerDetailsComponent, AbnAcnComponent, BorrowerTypeComponent,
    BorrowerTypeEnhancedComponent, TrustDetailsComponent, CompanyDetailsComponent, PersonalDetailsComponent, BusinessCarLoanDetailsComponent,
    LoanDetailsComponent, SingleSplitLoanAmountComponent, LoanTermsComponent, BalloonAmountComponent, EmploymentDetailsComponent,
    InvestmentIncomeComponent, IncomeDetailsComponent, AssetsDetailsComponent, LiabilitiesDetailsComponent, ExpensesDetailsComponent,
    AutoCollateralComponent, DocumentUploadComponent, SubmitComponent, ConfirmationComponent, QuoteDetailsComponent, QuotesListComponent,
    LoanDetailsTermsComponent, ApplicationTypeComponent, HomeLoanDetailsComponent, SecurityDetailsComponent, SolicitorPanelDetailsComponent,
    SolicitorBorrowerDetailsComponent, RateComponent, ProductComponent, BrokerNotesComponent, MatProgressSpinnerModule, MatProgressSpinnerModule]
})
export class WizardFormComponent implements OnInit {
  public externalApplication = false;
  public isInternalUser = false;
  public defaultData: any;
  public wizardName: string;
  public baseModel: any;
  public baseform: UntypedFormGroup;
  public faType: string;
  public faParentAppId: string;
  public activeStep = 0;
  public latestStep = 0;
  public loanPurposeType = '';
  public salesRelatesTo = '';
  public loading = true;
  // public activeStep = 1;
  public steps: WizardSteps[] = [];
  public storageIdentifier = 'wiz-base'; // the key for session storage
  public isHomeLoan = false;
  public isGreen = false;
  public isPartComplete = false;
  public setTbaAddress = false;
  public widgetMapper;

  public trustDetails: UntypedFormArray = new UntypedFormArray([]);
  public companyDetails: UntypedFormArray = new UntypedFormArray([]);
  public personalDetails: UntypedFormArray = new UntypedFormArray([]);

  public selectedCompany: CompanyDefaults;
  public isSMSF;
  public applicationData: any;
  public brokerDetails: any;
  public originatorDetails: any;
  public securityDetails: any;
  public selectedLoanProductType: any;
  public selectedLoanPurpose: any;
  public selectedLoanDescription: any;
  public selectedVehicle: any;
  public interestType: string;
  public investmentFormArray: any;
  public insuranceList: any;
  public expenseTypes: any;
  public currentPurchaseAmount: any;
  public applicationType: any;
  public loanTerm: any;
  public showPersonABN = false;
  public bidCompliance = false;
  public isMcca = false;
  public savedAppsDisplayed = false;
  public isLoading = false;
  public pndiPassed = false;
  public ndiPassed = false;
  public submitDisabled = false;
  public isLateInit = false;
  public ignoreExternalId = false;
  public checkNonApplicantValidation = false;
  public hasSettlement = true; // use this to add the settlement amount field in SSL
  public customerDetails = {};
  public borrowerType: String;
  public borrowerCount;
  public applicationSubmitted = false;
  public extraFees = []; // extra fees added to the fees of an application
  public caravanDisabled = false;
  public originationFeeValidationSwitch = false;
  public isFurtherAdvance = false;
  public featureSwitches: any = [];
  public types: any = ['feature-switches'];

  private navigatorSubject = new BehaviorSubject<String>(null);
  public navigator = this.navigatorSubject.asObservable();
  public subscriptions = [];
  public isNasApplicationType = false;
  public NAS_APPLICATION_TYPE = 'individual-with-non-applicant';
  private baseformStepZeroChangeStatusSubscription;

  // commented out for the moment because due to poor user experience and needs to be more targeted
  // @HostListener allows us to also guard against browser refresh, close, etc.
  // @HostListener('window:beforeunload')
  // canDeactivate(): boolean {
  //   return confirm('Please confirm');
  // }

  constructor(public formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService,
              public submissionService: SubmissionService,
              public applicationService: ApplicationService,
              public notificationService: NotificationService,
              public sanitizer: DomSanitizer,
              public oauthService: OAuthService,
              public router: Router,
              public activatedRoute: ActivatedRoute,
              public workbookService: WorkbookService,
              public typesService: TypesService,
              public communicationService: CommunicationService,
              public salesService: SalesService) {
  }

  protected getWidgetMapper() {
    return {
      'app-originator-broker': new OriginatorBrokerModel(),
      'app-customer-details': new CustomerDetailsModel(),
      'app-abn-acn': new AbnAcnModel(),
      'app-borrower-type': new BorrowerTypeModel(),
      'app-borrower-type-enhanced': new BorrowerTypeEnhancedModel(),
      'app-borrower-type-enhanced-smsf': new BorrowerTypeEnhancedModel(),
      'app-trust-details': new TrustDetailsModel(),
      'app-company-details': new CompanyDetailsModel(),
      'app-personal-details': new PersonalDetailsModel(),
      'app-business-car-loan-details': new CarLoanDetailsModel(),
      'app-auto-collateral': new AutoCollateralModel(),
      'app-balloon-amount': new BalloonAmountModel(),
      'app-loan-details': new LoanDetailsModel(),
      'app-loan-terms': new LoanTermsModel(),
      'app-single-split-loan-amount': new SingleSplitLoanAmountModel(),
      'app-docs-upload': new DocumentDetailsModel(),
      'app-income-details': new IncomeDetailsModel(),
      'app-employment-details': new EmploymentDetailsModel(),
      'app-investment-income': new InvestmentIncomeDetailsModel(),
      'app-assets-details': new AssetsDetailsModel(),
      'app-liabilities-details': new LiabilitiesDetailsModel(),
      'app-expenses-details': new ExpensesDetailsModel(),
      'app-submit': new SubmitModel(),
      'app-quote-details': new QuoteDetailsModel(),
      'app-quote-results': new QuoteResultsModel(),
      'app-quotes-list': new QuotesListModel(),
      'app-loan-details-terms': new LoanDetailsTermsModel(),
      'app-application-type': new ApplicationTypeModel(),
      'app-home-loan-details': new HomeLoanDetailsModel(),
      'app-security-details': new SecurityDetailsModel(),
      'app-solicitor-panel-details': new SolicitorPanelDetailsModel(),
      'app-solicitor-borrower-details': new SolicitorBorrowerDetailsModel(),
      'app-rate': new RateModel(),
      'app-product': new ProductModel(),
      'app-broker-notes': new BrokerNotesModel(),
    };
  }

  // so what should happen is everything maps to the base model
  // we declare the steps, and the widgets that are included in each step
  // also declare all the fields that will be required for each step
  ngOnInit() {
    this.getTypes()
      .subscribe((result: any) => {
        this.caravanDisabled = (this.featureSwitches && this.featureSwitches.find(x => x.id === 'caravan') && !this.featureSwitches.find(x => x.id === 'caravan').ext.enabled) ? true : false;
        this.originationFeeValidationSwitch = (this.featureSwitches && this.featureSwitches.find(x => x.id === 'fits-3133_tiered-origination-fee')) ? this.featureSwitches.find(x => x.id === 'fits-3133_tiered-origination-fee').ext.enabled : false;
      });

    // force login by car broker if no access was detected
    if (!this.oauthService.hasValidAccessToken()) {
      // console.log(this.activatedRoute.queryParamMap);
      // this.router.navigateByUrl('/broker-car');
    } else {
      const helper = new JwtHelperService();
      const decodedToken = helper.decodeToken(this.oauthService.getAccessToken());

      if (decodedToken && (decodedToken.name.includes('firstmac.com.au') || decodedToken.name.includes('1stm.ac'))) {
        this.isInternalUser = true;
      }

    }
    const init = this.checkForPartials.bind(this);
    init();

    this.setDataHandlerObservables();
  }

  public setDataHandlerObservables() {
    this.dataHandlerService.getMainBorrowerType()
      .subscribe((value) => {
        this.isNasApplicationType = (value === this.NAS_APPLICATION_TYPE);
        this.submitDisabled = (!this.pndiPassed && this.isNasApplicationType);
        console.log('submitDisabled', this.submitDisabled);
      });

    this.dataHandlerService.getNdiFlags()
      .subscribe((result: any) => {
        if (result) {
          this.pndiPassed = result.pndi;
          this.ndiPassed = result.ndi;
        }

        if (this.isNasApplicationType) {
          this.submitDisabled = (!this.pndiPassed && this.ndiPassed);
        } else {
          this.submitDisabled = false;
        }

        console.log('submitDisabled', this.submitDisabled);
        console.log('getPndiPassFlag', this.pndiPassed);
        console.log('getNdiPassFlag', this.ndiPassed);
        console.log('isNasApplicationType', this.isNasApplicationType);
      });
  }

  private checkForPartials() {
    console.log('checking for partial');

    // check for partial id in the query params
    this.activatedRoute.data
      .subscribe((res: any) => {
        // check if the form is active
        console.log('ACTIVATED ROUTE', res);

        const partialData = res.partial || {};
        const sessionPartial = JSON.parse(sessionStorage.getItem('partial-data'));
        // console.log('Checking for partials');

        if (partialData && partialData.id === 'clear') {
          this.ignoreExternalId = true;
        }

        console.log('partialData', partialData);
        console.log('sessionPartial', sessionPartial);

        if ((partialData.id && !sessionPartial) || (partialData.id && partialData.id !== sessionPartial._id)) {
          // clear the data because we are supposed to load this
          sessionStorage.removeItem(this.storageIdentifier);
          sessionStorage.removeItem(this.storageIdentifier + '-step');
          sessionStorage.removeItem(this.storageIdentifier + '-step-latest');

          if (sessionStorage.getItem('partial-data')) {
            sessionStorage.removeItem('partial-data');
          }

          console.log('partialData', partialData);

          // avoid retrieving invalid data -- initialize regardless
          if (partialData.id === 'null' || partialData.id === 'undefined' || partialData.id === 'clear') {
            sessionStorage.removeItem(this.storageIdentifier + '-step');
            sessionStorage.removeItem(this.storageIdentifier + '-step-latest');
            this.initializeForm();
            return;
          }

          this.activeStep = 0;
          partialData.step = '0';
          sessionStorage.setItem(this.storageIdentifier + '-step', partialData.step);
          sessionStorage.setItem(this.storageIdentifier + '-step-latest', partialData.step);

          if (partialData.data) {
            this.addPartialToSession(partialData.data._id, partialData.data.__v);
            this.mapPartialToSession(this.storageIdentifier, partialData.data.appData);
          }
        }

        if (partialData.faType) {
          console.log('is FA:::partialData', partialData);
          this.faType = partialData.faType;
          this.faParentAppId = partialData.faParentAppId;
          this.isFurtherAdvance = true;
        }

        console.log('init form');
        this.initializeForm();
      });
  }

  afterInit() {
    // override this since it is called after form is initialized
  }

  loadPartial(id, furtherAdvanceApplicationType?, faParentAppId?) {
    // console.log('[loadPartial]', id);
    // using the angular router does not fetch all partial data and set the form up correctly
    sessionStorage.removeItem('partial-data');
    const wiz = _.replace(this.storageIdentifier, 'wiz-', '');
    const wizUrl = (furtherAdvanceApplicationType) ? `/application/${wiz}?id=${id}&step=1&faType=${furtherAdvanceApplicationType}&faParentAppId=${faParentAppId}` : `/application/${wiz}?id=${id}&step=1`;
    window.open(wizUrl, '_self');
  }

  /**
   * Re-Initialise the formGroup model from Further Advance data model
   * @param data
   */
  public reInitializeForm(data: any ) {
    console.log('reInitializeForm', data);
    this.isFurtherAdvance = true;
    this.baseModel = data.model;
    this.faType = data.faType;
    this.faParentAppId = data.appId;

    sessionStorage.removeItem('partial-data');
    sessionStorage.removeItem(this.storageIdentifier);
    sessionStorage.removeItem(this.storageIdentifier + '-step');
    sessionStorage.removeItem(this.storageIdentifier + '-step-latest');

    // create base formGroup
    this.baseform = this.formBuilderService.convertObjectToFormGroup(this.baseModel);
    this.formBuilderService.setValidationRules(this.baseModel, this.baseform);

    // save base model
    sessionStorage.setItem(this.storageIdentifier, JSON.stringify(this.baseform.getRawValue()));
    sessionStorage.setItem('is-further-advance', 'true');

    this.savePartial(false, true);
  }

  /**
   * Initialises the formGroup and checks session storage for saved data
   * @private
   */
  private initializeForm(isFurtherAdvance = false) {
    console.log('[initializeForm] isFurtherAdvance', isFurtherAdvance);
    this.widgetMapper = this.getWidgetMapper();

    // do not capture data from session storage if furtherAdvanceApplication
    if (!isFurtherAdvance) {
      if (sessionStorage.getItem(this.storageIdentifier + '-step')) {
        this.activeStep = Number.parseInt(sessionStorage.getItem(this.storageIdentifier + '-step'));
      }

      if (sessionStorage.getItem(this.storageIdentifier + '-step-latest')) {
        this.latestStep = Number.parseInt(sessionStorage.getItem(this.storageIdentifier + '-step-latest'));
      }

      if (sessionStorage.getItem(this.storageIdentifier)) {
        this.defaultData = JSON.parse(sessionStorage.getItem(this.storageIdentifier));
      } else {
        this.defaultData = null;
      }

      this.baseModel = this.buildFormModel(this.defaultData);
    } else {
      this.subscriptions.forEach(sub => sub.unsubscribe());
      this.baseform.reset();
      this.baseform = null;
      this.activeStep = 0;
      this.latestStep = 0;
      sessionStorage.removeItem(this.storageIdentifier);
      sessionStorage.removeItem(this.storageIdentifier + '-step');
      sessionStorage.removeItem(this.storageIdentifier + '-step-latest');
    }

    // init the base form
    this.baseform = this.formBuilderService.convertObjectToFormGroup(this.baseModel);
    this.formBuilderService.setValidationRules(this.baseModel, this.baseform);
    console.log('BASEFORM', this.baseform);
    console.log('BASEMODEL', this.baseModel);

    if (this.baseform.get('step-1') && this.baseform.get('step-1').get('app-trust-details')) {
      this.trustDetails = (this.baseform.get('step-1').get('app-trust-details').get('trustList') as UntypedFormArray);
      this.trustDetails.controls.forEach(fg => {
        this.formBuilderService.setValidationRules(new IndividualTrustModel(), fg);
      });
    } else {
      this.trustDetails = new UntypedFormArray([]);
    }

    if (this.baseform.get('step-1') && this.baseform.get('step-1').get('app-company-details')) {
      this.companyDetails = (this.baseform.get('step-1').get('app-company-details').get('companyList') as UntypedFormArray);
      this.companyDetails.controls.forEach(fg => {
        this.formBuilderService.setValidationRules(new IndividualCompanyModel(), fg);
      });
    } else {
      this.companyDetails = new UntypedFormArray([]);
    }

    if (this.baseform.get('step-1') && this.baseform.get('step-1').get('app-personal-details').get('personList')) {
      this.personalDetails = (this.baseform.get('step-1').get('app-personal-details').get('personList') as UntypedFormArray);
      this.personalDetails.controls.forEach(fg => {
        this.formBuilderService.setValidationRules(new IndividualPersonModel(), fg);
      });
    }

    // originators
    if (this.baseform.get('step-0') && this.baseform.get('step-0').get('app-originator-broker') as UntypedFormGroup) {
      const fg = this.baseform.get('step-0') && this.baseform.get('step-0').get('app-originator-broker') as UntypedFormGroup;
      this.formBuilderService.setValidationRules(new OriginatorBrokerModel(), fg);
    }


    this.baseform.valueChanges.pipe(
      startWith(this.baseform.value),
      pairwise(),
      debounceTime(100)
    ).subscribe(([old, newValue]) => {
      const isSame = _.isEqual(old, newValue);
      if (!this.applicationData && !isSame) {
        sessionStorage.setItem(this.storageIdentifier, JSON.stringify(this.baseform.getRawValue()));
      }
    });

    if (this.baseform.get('step-1')) {
      this.baseform.get('step-1').valueChanges.pipe(debounceTime(100)).subscribe(() => {
        this.applicationService.getApplicationAddresses(this.baseform.getRawValue()['step-1']);
      });
    }

    this.baseformStepZeroChangeStatusSubscription = this.baseform.get('step-0').statusChanges.pipe().subscribe((status) => {
      if (status === 'VALID') {
        this.baseformStepZeroChangeStatusSubscription.unsubscribe();
        this.validateSteps();
      }
    });

    this.loading = false;

    this.navigator.subscribe(this.navigateToWidget.bind(this));

    this.afterInit();
    this.validateSteps();
  }

  toggleSavedAppsList(ev) {
    if (this.isHomeLoan) {
      this.savedAppsDisplayed = ev;
    }
  }

  toggleWidget(enabled, widgetName) {
    const step = this.getStep(widgetName);
    const widget = this.getWidget(widgetName);
    const models = this.getWidgetMapper();
    if (enabled) {
      if (!widget) {
        const fg = this.formBuilderService.convertObjectToFormGroup(models[widgetName]);
        this.formBuilderService.setValidationRules(models[widgetName], fg);
        step.setControl(widgetName, fg);
      }
    } else {
      if (widget) {
        step.removeControl(widgetName);
        step.updateValueAndValidity();
      }
    }
    step.updateValueAndValidity();
  }

  public getWidget(widgetName) {
    return this.getStep(widgetName).get(widgetName) as UntypedFormGroup;
  }

  public getStep(widgetName) {
    const stepIdx = this.steps.findIndex(s => !!s.widgets.find(w => w.name === widgetName));
    return this.baseform.get(`step-${stepIdx}`) as UntypedFormGroup;
  }

  public navigateToWidget(widgetName) {
    if (widgetName) {
      const stepIdx = this.steps.findIndex(s => !!s.widgets.find(w => w.name === widgetName));
      if (!isNaN(stepIdx) && stepIdx !== null && stepIdx >= 0) {
        this.navigateToStep(stepIdx);
      }
      if (widgetName) {
        this.scroll(widgetName);
      }
    }
  }

  private buildFormModel(defaultData) {
    // this.baseform = new FormGroup({});
    let idx = 0;
    const newModel = {};
    console.log('widgetMapper', this.widgetMapper);
    console.log('defaultData', defaultData);
    const sessionDefaults = window.sessionStorage.getItem('wiz-defaults');

    this.steps.forEach(step => {
      const stepId = `step-${idx++}`;
      newModel[stepId] = {};
      step.widgets.forEach(widget => {
        if (this.widgetMapper[widget.name]) {
          newModel[stepId][widget.name] = this.widgetMapper[widget.name];
          if (defaultData && defaultData[stepId] && defaultData[stepId][widget.name]) {
            for (const controlName in newModel[stepId][widget.name]) {
              const val = defaultData[stepId][widget.name][controlName];
              if (val !== undefined && val !== null) {
                newModel[stepId][widget.name][controlName].value = val;
              }
            }
          } else {
            const widgetData = (sessionDefaults) ? JSON.parse(sessionDefaults)[widget.name] : null;
            if (!defaultData && sessionDefaults && widgetData) {
              for (const controlName in newModel[stepId][widget.name]) {
                if (widgetData[controlName] !== undefined && widgetData[controlName] !== null) {
                  // console.log('[buildFormModel]', widgetData[controlName]);
                  newModel[stepId][widget.name][controlName].value = widgetData[controlName];
                  // console.log('[personDetails]', this.personalDetails);
                }
              }
            }
          }
        } else {
          console.log('[buildFormModel]', 'Undefined widget model:', widget);
        }
      });
    });

    return newModel;
  }

  public submitApplication() {
    const data = this.baseform.getRawValue();
    console.log('Form submission ', data);
    console.log('Form Valid?', this.baseform);

    if ((this.baseform.valid || this.baseform.pending) && !this.applicationSubmitted) {
      this.savePartial();
      this.isLoading = true;
      this.submitDisabled = true;
      this.applicationSubmitted = true;
      // Check if submission-api is up
      this.applicationService.checkVersion()
        .subscribe(version => {
          // console.log('[version]', version);
          if (version.length === 0) {
            this.applicationData = [];
            this.activeStep = this.activeStep + 1;

            this.steps[(this.activeStep - 1)].classNameStatus = 'complete';
            this.steps[this.activeStep].classNameStatus = 'active';

            sessionStorage.setItem(this.storageIdentifier + '-step', this.activeStep.toString());
            this.setLatestStep();
            this.formBuilderService.showValidationErrors.next(false);
          } else {
            let body = null;
            try {
              body = this.formBeforeSubmit(data);
            } catch (e) {
              // catch submission.service errors
              console.error(e);
              const errData = Object.assign({}, {error: {stack: e.stack, message: e.message}}, data);
              this.applicationService.submitError({
                wizardData: errData
              }).subscribe((val) => {
                this.notificationService.toast('error', `packet: ${val._id}`, 'Error during submission processing.');
                this.isLoading = false;
                this.submitDisabled = false;
                console.log('Error sent to submission-api');
              });
              return;
            }

            const partialDetails: any = JSON.parse(sessionStorage.getItem('partial-data'));

            console.log('[partialDetails]', partialDetails);
            // body._id = (partialDetails && partialDetails._id) ? partialDetails._id : null;
            // body.progress = {
            //   status: 'completed'
            // };
            this.applicationService.submitApplication(body)
              .subscribe(result => {
                this.isLoading = false;
                this.submitDisabled = false;
                console.log('[SUBMIT]', result);
                this.applicationData = result;
                this.steps[this.activeStep].classNameStatus = 'complete';
                this.activeStep = this.activeStep + 1;
                this.steps[this.activeStep].classNameStatus = 'active';
                sessionStorage.setItem(this.storageIdentifier + '-step', this.activeStep.toString());
                this.setLatestStep();
                this.formBuilderService.showValidationErrors.next(false);

                if (
                  this.applicationData &&
                  !(Array.isArray(this.applicationData)) &&
                  this.applicationData.applicationIds && this.applicationData.applicationIds.length >= 1) {
                  this.clearPartialData();
                } else {
                  // to show the `Save application` button when there's an error upon submitting the application.
                  this.applicationSubmitted = false;
                }
              }, (error) => {
                console.log('submit application Error: :>> ', error);
                this.applicationSubmitted = false;
              });
          }
        });
    } else if (!this.baseform.valid && !this.applicationSubmitted) {
      this.applicationSubmitted = false;
      console.log('[wizard-form]', '[submitApplication]', '[INVALID]', this.baseform);
      this.formBuilderService.showValidationErrors.next(true);
      this.notificationService.toast('error', 'Please check the form for validation errors.', 'Form validation error');
      // this.steps[this.activeStep].classNameStatus = 'error';
      this.validateSteps();
    } else if (this.applicationSubmitted) {
      this.notificationService.toast('warn', 'This application has already been submitted', 'Info');
    }
  }

  public clearPartialData() {
    console.log('Clearing partial data');
    this.isGreen = false;
    const partialDetails = JSON.parse(sessionStorage.getItem('partial-data'));
    if (partialDetails && partialDetails._id) {
      // this.salesService.deletePartial(partialDetails._id).subscribe((res) => {
      //   console.log('Partial submission cleared');
      // });
    }
  }

  public formBeforeSubmit(data) {
    // check if session storage has lead
    let lead;
    try {
      lead = JSON.parse(sessionStorage.getItem(this.storageIdentifier + '-lead'));
    } catch {
      console.log('Unable to parse lead from session storage: ' + sessionStorage.getItem(this.storageIdentifier + '-lead'));
      lead = null;
    }

    // override this to add any additional data like workflows
    const defaults: SubmissionDefaults = {
      purposeType: this.loanPurposeType,
      salesRelatesTo: this.salesRelatesTo,
      shop: (lead && lead.shop) ? lead.shop : null,
      channel: (lead && lead.channel) ? lead.channel : null,
    };

    this.dataHandlerService.getIsRetailFlag()
      .pipe(take(1))
      .subscribe((isRetail: Boolean) => {
        if (isRetail && RETAIL.FMCDIRECT === this.originatorDetails.id) {
          defaults.shop = 'firstmac-retail';
        }
      });

    const packet: any = this.submissionService.parse(data, defaults);

    if (lead && !this.ignoreExternalId) {
      if (lead.leadId && !isNaN(lead.leadId)) {
        packet['lead']['id'] = parseInt(lead.leadId, 10);
      } else if (lead.id && !isNaN(lead.id)) {
        packet['lead']['id'] = parseInt(lead.id, 10);
      } else {
        return packet;
      }
    }

    if (lead && lead.shop) {
      packet.lead.shop = lead.shop;
    }

    if (lead && lead.channel) {
      packet.lead.channel = lead.channel;
    }

    delete packet['defaults'];
    return packet;
  }

  public clearFormArray(formArray: UntypedFormArray) {
    while (formArray && formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }

  public updateAbnValidation(disable) {
    if (disable && this.baseform.get('step-0').get('app-abn-acn')) {
      // disable required validation on ABN
      this.baseform.get('step-0').get('app-abn-acn').get('abnAcnConfirmation').clearValidators();
      this.baseform.get('step-0').get('app-abn-acn').get('abnAcnConfirmation').updateValueAndValidity();
      this.baseform.get('step-0').get('app-abn-acn').get('abnAcnNumber').clearValidators();
      this.baseform.get('step-0').get('app-abn-acn').get('abnAcnNumber').updateValueAndValidity();
    } else if (!disable && this.baseform.get('step-0').get('app-abn-acn')) {
      this.baseform.get('step-0').get('app-abn-acn').get('abnAcnConfirmation').setValidators(Validators.required);
      this.baseform.get('step-0').get('app-abn-acn').get('abnAcnConfirmation').updateValueAndValidity();
      this.baseform.get('step-0').get('app-abn-acn').get('abnAcnNumber').setValidators(Validators.required);
      this.baseform.get('step-0').get('app-abn-acn').get('abnAcnNumber').updateValueAndValidity();
    }
  }

  public handleBorrowingTypeChange(change: BorrowerTypeInfo, trustFormGroup = null) {
    console.log('handleBorrowingTypeChange', change);
    this.borrowerCount = change.borrowerCount || this.borrowerCount;
    if (!change.borrowingType || !change.borrowingType.id) {
      return;
    }
    const previousBorrowerType = this.borrowerType;

    this.borrowerType = change.borrowingType.id;

    // remove required validation on the abn

    // patch the trust values
    const companyFormArray = this.companyDetails;

    // if this is a trust
    if (this.borrowerType.indexOf('trust') !== -1) {
      this.showPersonABN = false;

      this.updateAbnValidation(true);

      // push a trust
      if (this.trustDetails.length === 0) {
        const trustModel = new IndividualTrustModel();


        if (this.selectedCompany) {
          trustModel.trustABN.value = this.selectedCompany.abn;
          trustModel.trustName.value = this.selectedCompany.name;
          // trustModel.trustACN.value = this.selectedCompany.acn;
          trustModel.ext.value = this.selectedCompany.asic;
        }
        const trustFg = this.formBuilderService.convertObjectToFormGroup(trustModel);
        this.formBuilderService.setValidationRules(new IndividualTrustModel(), trustFg);
        // console.log('[TRUST]', this.trustDetails);
        this.trustDetails.push(trustFg);
      }
      if (this.borrowerType.indexOf('company') !== -1) {
        // push a company
        const companyModel = new IndividualCompanyModel();
        if (this.companyDetails.length === 0) {
          const companyFg = this.formBuilderService.convertObjectToFormGroup(companyModel);
          this.formBuilderService.setValidationRules(new IndividualCompanyModel(), companyFg);
          this.companyDetails.push(companyFg);
        }
      }

      // company only
    } else if (this.borrowerType.indexOf('company') !== -1) {
      this.clearFormArray(this.trustDetails);
      this.showPersonABN = false;

      this.updateAbnValidation(false);

      if (this.companyDetails.length === 0) {
        const model = new IndividualCompanyModel();
        if (this.selectedCompany) {
          model.companyABN.value = this.selectedCompany.abn;
          model.companyName.value = this.selectedCompany.name;
          model.companyACN.value = this.selectedCompany.acn;
          model.ext.value = this.selectedCompany.asic;
        }
        const companyFg = this.formBuilderService.convertObjectToFormGroup(model);
        this.formBuilderService.setValidationRules(new IndividualCompanyModel(), companyFg);
        this.companyDetails.push(companyFg);
      }

    } else {
      this.updateAbnValidation(false);
      this.clearFormArray(this.trustDetails);
      this.clearFormArray(this.companyDetails);
      this.showPersonABN = false;
      // partnership and sole
      if (change.borrowingType.id.indexOf('sole-trader') !== -1 || change.borrowingType.id.indexOf('partnership') !== -1) {
        this.showPersonABN = true;
      }
    }
    this._togglePersonAbn();

    // populate the individual details
    const individualDetails: UntypedFormArray = this.personalDetails;
    let curLength = individualDetails.controls.length;

    if (!this.isFurtherAdvance) {
      if (previousBorrowerType === 'individual-with-non-applicant' && this.borrowerType !== previousBorrowerType) {
        if (curLength === 2) {
          // remove the NAS.
          individualDetails.removeAt(1);
          // update the length of `curLength`
          curLength = individualDetails.controls.length;
        }
      }

      if (curLength > change.borrowerCount) {
        for (let index = curLength - 1; index >= change.borrowerCount; index--) {
          individualDetails.removeAt(index); // remove the individual details
        }
      } else if (curLength < change.borrowerCount) {
        for (let index = curLength; index < change.borrowerCount; index++) {
          let addPersonModel: any = new IndividualPersonModel();

          if (this.borrowerType === 'individual-with-non-applicant' && index === 1) {
            console.log('added new NAS');

            addPersonModel = new IndividualNonApplicantModel();
            const indivFg = this.formBuilderService.convertObjectToFormGroup(addPersonModel);
            this.formBuilderService.setValidationRules(new IndividualNonApplicantModel(), indivFg);
            individualDetails.controls.push(indivFg);
          } else {
            if (this.selectedCompany) {
              addPersonModel.orgName.value = this.selectedCompany.name;
              addPersonModel.orgABN.value = this.selectedCompany.abn;
              addPersonModel.showPersonABN.value = this.showPersonABN;
              addPersonModel.ext.value = this.selectedCompany.asic;
            }
            const indivFg = this.formBuilderService.convertObjectToFormGroup(addPersonModel);
            this.formBuilderService.setValidationRules(new IndividualPersonModel(), indivFg);
            individualDetails.push(indivFg);
          }
        }
      } else {
        console.log('change.borrowingType', change.borrowingType);
        console.log('curLength', curLength);
        console.log('change.borrowerCount', change.borrowerCount);
        console.log('personalDetails', this.personalDetails);
      }
    }
  }

  private _togglePersonAbn() {
    // console.log('[_togglePersonAbn]');
    if (this.personalDetails.length === 0) {
      const personModel = new IndividualPersonModel();
      if (this.selectedCompany) {
        personModel.orgName.value = this.selectedCompany.name;
        personModel.orgABN.value = this.selectedCompany.abn;
      }
      personModel.showPersonABN.value = this.showPersonABN;

      const personFg = this.formBuilderService.convertObjectToFormGroup(personModel);
      this.formBuilderService.setValidationRules(new IndividualPersonModel(), personFg);
      this.personalDetails.push(personFg);
    } else if (this.personalDetails.length > 0) {
      if (this.selectedCompany) {
        this.personalDetails.at(0).patchValue({
          orgName: this.selectedCompany.name,
          orgABN: this.selectedCompany.abn
        }, {emitEvent: false});

        this.personalDetails.at(0).patchValue({
          showPersonABN: this.showPersonABN
        }, {emitEvent: false});
        // } else {
        //   this.personalDetails.at(0).patchValue({
        //     showPersonABN: this.showPersonABN
        //   }, { emitEvent: false });
      }
    }
    this._populateCustomerDetails();
  }

  private _populateCustomerDetails() {
    console.log('_populateCustomerDetails');

    // add customer details, if available
    let middleName = '';

    if (this.customerDetails['name']) {
      const nameArr = this.customerDetails['name'].split(' ');
      nameArr.forEach((n, i) => {
        if (i === 0) {
          this.personalDetails.at(0).patchValue({firstName: n}, {emitEvent: false});
        } else if (i === nameArr.length - 1) {
          this.personalDetails.at(0).patchValue({middleName: middleName.trim()}, {emitEvent: false});
          this.personalDetails.at(0).patchValue({lastName: n}, {emitEvent: false});
        } else {
          middleName += n + ' ';
        }
      });
    }

    if (this.customerDetails['email']) {
      this.personalDetails.at(0).patchValue({email: this.customerDetails['email']});
    }

    if (this.customerDetails['phone']) {
      if (!this.personalDetails.at(0).get('phones')) {
        const formarray = new UntypedFormArray([]);
        const phone = new IndividualPhoneModel();
        const fg = this.formBuilderService.convertObjectToFormGroup(phone);
        this.formBuilderService.setValidationRules(new IndividualPhoneModel(), fg);
        formarray.push(fg);
        const person = <UntypedFormGroup>this.personalDetails.at(0);
        person.setControl('phones', formarray);
      }
      // only patch if there is no phoneNumber yet
      const firstPersonfirstPhone = (this.personalDetails.at(0).get('phones') as UntypedFormArray).at(0);
      firstPersonfirstPhone.patchValue({phoneNumber: this.customerDetails['phone']}, {emitEvent: false});
    }
  }

  public getGeneralBlurb() {
    return this.sanitizer.bypassSecurityTrustHtml(
      `<div>CONTENT TBD</div>`
    );
  }

  public progressPrevStep(step) {
    console.log('progressPrevStep');

    // check if step is to be shown
    if (this.showStep(step)) {
      this.activeStep = this.activeStep - 1;
    } else {
      this.activeStep = this.activeStep - 2;
    }
    sessionStorage.setItem(this.storageIdentifier + '-step', this.activeStep.toString());
    this.validateSteps();
  }

  setLatestStep() {
    if (this.activeStep > this.latestStep) {
      this.latestStep = this.activeStep;
      sessionStorage.setItem(this.storageIdentifier + '-step-latest', this.latestStep.toString());
    }
  }

  removeLatestStep() {
    if (this.latestStep) {
      sessionStorage.removeItem(this.storageIdentifier + '-step-latest');
    }
  }

  public findErrorsRecursive(formToInvestigate: any): ValidationErrors[] {
    const errors: ValidationErrors[] = [];
    const recursiveFunc = (form: UntypedFormGroup | UntypedFormArray) => {
      Object.keys(form.controls).forEach((field) => {
        const control = form.get(field);
        if (control?.errors || control?.invalid) {
          errors.push(control.errors);
        } else if (!control?.errors) {
          control.setErrors(null, {emitEvent: false});
          control.updateValueAndValidity({emitEvent: false});
        }
        if (control instanceof UntypedFormGroup) {
          recursiveFunc(control);
        } else if (control instanceof UntypedFormArray) {
          if (control?.errors) {
            errors.push(control.errors);
          } else if (!control?.errors) {
            control.setErrors(null, {emitEvent: false});
            control.updateValueAndValidity({emitEvent: false});
          }

          recursiveFunc(control);
        }
      });
    };
    recursiveFunc(formToInvestigate);
    return errors;
  }

  public progressNextStep(step) {
    console.log('progressNextStep');
    console.log('errors', this.findErrorsRecursive(this.baseform.get('step-' + this.activeStep)));
    console.log('formGroup', this.baseform.get('step-' + this.activeStep));

    if (this.activeStep === 1) {
      const personListCount = this.baseform.get('step-' + this.activeStep).get('app-personal-details').get('personList').value.length;

      if (this.borrowerCount > personListCount) {
        this.notificationService.toast('error', 'Number of persons added should be equivalent to number of borrowers', 'Validation Error');
        return;
      }
    }
    const errors = this.findErrorsRecursive(this.baseform.get('step-' + this.activeStep));
    if (this.baseform.get('step-' + this.activeStep).valid || errors.length === 0) {
      // save partials
      if (this.activeStep > 0) {
        this.savePartial();
      }
      // check if step is to be shown
      if (this.showStep(step)) {
        // this.baseform.get('step-' + (this.activeStep + 1)).enable();
        this.activeStep = this.activeStep + 1;
      } else {
        // remove validators
        // this.baseform.get('step-' + (this.activeStep + 1)).disable();
        // skip a step
        this.activeStep = this.activeStep + 2;
      }
      sessionStorage.setItem(this.storageIdentifier + '-step', this.activeStep.toString());
      this.setLatestStep();
      this.formBuilderService.showValidationErrors.next(false);

      // this.dataHandlerService.setActiveComponents(this.steps[this.activeStep]);

      // always load to the top of the page on next
      document.getElementById('contentBody').scrollTop = 0;

      // this.steps[(this.activeStep - 1)].classNameStatus = 'complete';
      // this.steps[this.activeStep].classNameStatus = 'active';
      this.validateSteps();
    } else {
      console.log('Invalid Fields', this.formBuilderService.getAllInvalidFields(this.baseform.get('step-' + this.activeStep)));
      this.formBuilderService.showValidationErrors.next(true);
      this.markFormGroupTouched(this.baseform.get('step-' + this.activeStep) as UntypedFormGroup);
      this.notificationService.toast('warn', 'There are errors on this page. Please fix before progressing.', 'Validation Error');

      this.validateSteps();

      // scroll to first error on the page
      const firstElementWithError = document.querySelector('.ng-invalid');
      firstElementWithError.scrollIntoView({behavior: 'smooth'});
    }
  }

  public savePartial(saveClicked = false, redirect = false) {
    if (this.isPartComplete) {
      console.log('[NEXT]', 'save cache in mongodb', this.brokerDetails);
      console.log('[NEXT]', 'storage id', this.storageIdentifier);

      const partialData = {};
      const partialDetails = JSON.parse(sessionStorage.getItem('partial-data'));
      const sessionData = JSON.parse(sessionStorage.getItem(this.storageIdentifier));

      console.log('sessionData', sessionData);
      console.log('partialDetails', partialDetails);

      Object.keys(sessionData).forEach(key => {
        Object.assign(partialData, sessionData[key]);
      });
      const data = {
        brokerId: (this.brokerDetails) ? this.brokerDetails.id : null,
        'appType': this.storageIdentifier,
        'appData': partialData,
        _id: (partialDetails && partialDetails._id) ? partialDetails._id : null,
        progress: {
          status: 'in-progress'
        }
      };

      // check for firstname and lastname before saving application data
      if (saveClicked && partialData && partialData['app-personal-details'] && partialData['app-personal-details'].personList.length > 0) {
        if (!partialData['app-personal-details'].personList[0].firstName || !partialData['app-personal-details'].personList[0].lastName) {
          this.notificationService.toast('error', 'Please enter the person\'s first and last names before clicking save', 'Error');
          return;
        }
      }

      if (partialDetails && partialDetails._id) {
        data['__v'] = partialDetails.__v;
        this.salesService.updatePartial(partialDetails._id, data)
          .subscribe((res) => {
            console.log('[update-partial]', res);
            this.addPartialToSession(partialDetails._id, partialDetails.__v + 1);

            if (saveClicked) {
              this.notificationService.toast('success', 'Your application has been saved', 'Success');
            }
          });
      } else {
        this.salesService.createPartial(data).subscribe({
          next: (res) => {
            console.log('[save-partial]', res);
            this.addPartialToSession(res, 0);

            if (saveClicked) {
              this.notificationService.toast('success', 'Your application has been saved', 'Success');
            }

            if (redirect) {
              this.loadPartial(res, this.faType, this.faParentAppId);
            }
          },
          error: (error) => {
            console.error('An error occurred on createPartial:', JSON.stringify(error, null, 2));
          },
          complete: () => {
            console.log('Partial save operation completed.');
          }
        });
      }
    }
  }

  public addPartialToSession(id, ver) {
    console.log('id ver', id, ver);

    const saveDetails: any = {
      _id: id,
      __v: ver
    };
    sessionStorage.setItem('partial-data', JSON.stringify(saveDetails));
  }

  public mapPartialToSession(type, data) {
    const dataToSave = {};

    if (data && Object.keys(data).length > 0) {
      Object.keys(data).forEach(key => {
        const stepId = this.getStepIndex(key);
        console.log('[mapPartialToSession]', key, stepId);
        if (stepId >= 0) {
          const step = 'step-' + stepId;
          if (!dataToSave[step]) {
            dataToSave[step] = {};
          }
          dataToSave[step][key] = data[key];
        } else {
          if (key === 'lead') {
            console.log('[lead]', data[key]);
            sessionStorage.setItem(type + '-lead', JSON.stringify(data[key]));
          } else {
            console.log('[mapPartialToSession] Not a step?', key);
          }
        }
      });
    }
    // return dataToSave;
    console.log('[mapPartialToSession]', dataToSave);
    sessionStorage.setItem(type, JSON.stringify(dataToSave));
  }

  private getStepIndex(widget) {
    let index = -1;
    this.steps.forEach((step, i) => {
      if (step.widgets.find(x => x.name === widget)) {
        index = i;
      }
    });
    return index;
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  public markFormGroupTouched(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).map(x => {
      const control = formGroup.controls[x] as any;
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public isStepComplete(stepIdx) {
    const invalidFormControls = this.formBuilderService.getAllInvalidFields(this.baseform.get('step-' + stepIdx));
    return (this.baseform
      && this.baseform.get('step-' + stepIdx).valid || (invalidFormControls.length === 0
        && (this.activeStep !== stepIdx)
        && (this.latestStep > stepIdx)));
  }

  public stepHasErrors(stepIdx) {
    return (this.baseform
      && (this.baseform.get('step-' + stepIdx).invalid || this.formBuilderService.getAllInvalidFields(this.baseform.get('step-' + stepIdx)).length >= 1)
      && (this.latestStep > stepIdx));
  }

  public getStepIcon(stepIdx) {
    if (this.isStepComplete(stepIdx)) {
      return 'check';
    } else if (this.stepHasErrors(stepIdx)) {
      return 'error';
    } else {
      return this.steps[stepIdx].icon;
    }
  }

  public getStepClass(stepIdx, fromNextStep = false) {
    const errors = this.findErrorsRecursive(this.baseform.get('step-' + stepIdx));
    const hasError = errors.length > 0;
    const isCompleted = this.isStepComplete(stepIdx);

    if (stepIdx <= this.latestStep && hasError) {
      this.steps[stepIdx].classNameStatus = 'error';
    } else if (stepIdx === this.activeStep && fromNextStep && hasError) {
      this.steps[stepIdx].classNameStatus = 'error';
    } else if (stepIdx === this.activeStep) {
      this.steps[stepIdx].classNameStatus = 'active';
    } else if (isCompleted) {
      this.steps[stepIdx].classNameStatus = 'complete';
    } else {
      this.steps[stepIdx].classNameStatus = 'default';
    }
  }

  public showStep(step) {
    if (step.condition && typeof step.condition === 'function') {
      return step.condition(this);
    }
    return true;
  }

  public handleLoanProductTypeChange(data) {
    // console.log('[handleLoanProductTypeChange]', id);
    this.selectedLoanProductType = data;
  }

  public handleLoanPurposeChange(id) {
    // console.log('[handleLoanPurposeChange]', id);
    this.selectedLoanPurpose = id;
  }

  public handleLoanDescriptionChange(data) {
    console.log('[handleLoanDescriptionChange]', data);
    this.selectedLoanDescription = data;
  }

  public handleVehicleChange(data) {
    console.log('[handleVehicleChange]', data);
    this.selectedVehicle = data;
  }

  public handleInterestType(data) {
    console.log('[handleInterestType]', data);
    this.interestType = data;
  }

  public handleIsGreen(data) {
    console.log('[handleIsGreen]', data);
    this.isGreen = data;
  }

  public handlePurchaseAmountChange(data) {
    this.currentPurchaseAmount = data;
  }

  public handleApplicationTypeChange(data) {
    this.applicationType = data;
  }

  public handleBrokerDetailsChange(data) {
    // console.log('[handleBrokerDetailsChange]', data);
    this.brokerDetails = data;
  }

  public handleOriginatorDetailsChange(data) {
    console.log('[handleOriginatorDetailsChange]', data);

    this.isMcca = data.name && !!(data.name.includes('mcca'));
    this.originatorDetails = data;

    this.dataHandlerService.getBidCompliantFlag().subscribe((result: any) => {
      this.bidCompliance = result;
    });
  }

  public handleSecurityDetailsChange(data) {
    console.log('[handleSecurityDetailsChange]', data);
    this.securityDetails = data;
  }

  public handledInsuranceList(data) {
    // console.log('[handledInsuranceList]', data);
    this.insuranceList = data;
  }

  public navigateToStep(stepIdx) {
    // this.getStepClass(this.activeStep);
    if (stepIdx <= this.latestStep) {
      this.steps[stepIdx].classNameStatus = 'active';
      this.activeStep = stepIdx;
      sessionStorage.setItem(this.storageIdentifier + '-step', this.activeStep.toString());
    } else {
      this.notificationService.toast('warn', 'Please complete the latest step before proceeding.');
    }
    this.validateSteps(stepIdx);
  }

  public validateSteps(excludedStep: number = -1) {
    this.steps.forEach((step: any, index: number) => {
      if (index <= this.latestStep && index !== excludedStep) {
        this.getStepClass(index);
      }
    });
  }

  public handleLoanTermChange(data) {
    // console.log('[handleLoanTermChange]', data);
    this.loanTerm = data;
  }

  public handleExpenseTypesChange(data) {
    // console.log('[handleExpenseTypesChange]', data);
    this.expenseTypes = data;
  }

  public handleCustomerDetails(data) {
    this.customerDetails = data;
    if (this.personalDetails && this.personalDetails.length > 0) {
      this._populateCustomerDetails();
    }
  }

  scroll(id) {
    // delayed scrolling
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView();
      } else {
        console.warn('Element to scroll to not found', id);
      }
    }, 1000);
  }

  public resetForm() {
    const accept = confirm('This will remove all inputted data, do you want to proceed?');
    if (accept) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
      this.baseform.reset();
      this.baseform = null;
      this.activeStep = 0;
      this.latestStep = 0;
      this.loading = true;
      this.isFurtherAdvance = false;
      setTimeout(() => {
        sessionStorage.removeItem(this.storageIdentifier);
        sessionStorage.removeItem(this.storageIdentifier + '-step');
        sessionStorage.removeItem(this.storageIdentifier + '-step-latest');
        this.router.navigate(['/']);
        this.initializeForm();
      }, 1000);
    }
  }

  getTypes(): Observable<any> {
    return new Observable(observer => {
      this.typesService.getTypes(this.types).subscribe(
        lists => {
          lists.forEach((list, index) => {
            this[_.camelCase(this.types[index])] = list;
          });
          observer.next(null);
          observer.complete();
        },
        error => {
          console.log(error);
          observer.error(error);
        });
    });
  }
}
